import type {ReactNode} from 'react'
import {detailColumn} from './detail-column.module.scss'

type Props = {
  children: ReactNode
}

export default function DetailColumn({children}: Props) {
  return <div className={detailColumn}>{children}</div>
}
